import styled from "styled-components";
import { ColorVariables } from "../Colors";
import { ReactComponent as IconRemove } from "../Images/icons/Remove.svg";
import { baseLength } from "../Styles/globals";
import { FlexContainer } from "../Containers";

export const StyledClosableTile = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  padding: 12px;
  width: 100%;
  background: ${ColorVariables.sugar};
  border: 1px solid ${ColorVariables.coco3};
  border-radius: 8px;
  box-shadow: 0px 4px 4px rgba(208, 204, 193, 0.6);
  position: relative;
  .closeableTile__content {
    flex: 1;
    margin-right: 30px;
    text-align: left;
  }
  .closeableTile__close {
    margin-left: auto;
    width: 30px;
    height: 30px;
    border-radius: 8px;
    svg {
      fill: ${ColorVariables.coco3};
      width: 10px;
      height: 10px;
    }
    &:hover {
      background: ${ColorVariables.coco05};
    }
  }
  &:hover {
    box-shadow: 0px 7px 4px rgba(208, 204, 193, 0.6);
  }
  &:active {
    box-shadow: 0px 7px 4px rgba(208, 204, 193, 0.6);
  }
`;

export const StyledBaseTile = styled(FlexContainer)<{ clickable?: boolean }>`
  background-color: ${ColorVariables.sugar};
  //box-shadow: 0px 4px 4px rgba(208, 204, 193, 0.6);
  padding: ${`${baseLength * 3.75}px ${baseLength * 3.75}px ${baseLength * 3.75}px ${baseLength * 3.75}px`};
  border-radius: ${baseLength * 2.5}px;
  cursor: pointer;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  word-break: break-word;
  border: solid 0px transparent;
  cursor: ${(props) => (props.clickable ? "pointer" : "inherit")};
  transition: width 0.1s ease-in, height 0.1s ease-in, border-color 0.05s ease-in, box-shadow 0.05s ease-in;
  border: 1px solid ${ColorVariables.coco3};

  //&:hover {
  //  box-shadow: 0px 7px 4px rgba(208, 204, 193, 0.6);
  //}
  //
  //&:active {
  //  box-shadow: 0px 7px 4px rgba(208, 204, 193, 0.6);
  //}
`;

export const AllocationTileWrapper = styled(StyledBaseTile)`
  display: block;
  background: ${ColorVariables.orange3};
  border: 1px solid ${ColorVariables.coco3};
  box-shadow: none;
  max-width: 600px;
  margin: 0 auto;
  padding: 16px;
  @media (min-width: 769px) {
    padding: 20px;
  }

  tr {
    vertical-align: top;
  }
  th,
  td {
    &:first-child {
      padding-right: 20px;
    }
    &:last-child {
      width: 35%;
    }
  }
`;

export const AllocationTileHeader = styled.div`
  h2 {
    font-size: 24px;
    line-height: 1.3;
    font-weight: 600;
    text-align: center;
  }
  p {
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    margin-top: 20px;
  }
  @media (min-width: 769px) {
    h2 {
      font-size: 40px;
    }
    p {
      margin-top: 42px;
      font-size: 14px;
      line-height: 22px;
    }
    padding: 22px 0;
  }
`;

export const AllocationTileContent = styled.div`
  margin-top: 22px;
  h3 {
    font-size: 16px;
    line-height: 24px;
  }
  @media (min-width: 769px) {
    h3 {
      font-size: 18px;
      line-height: 26px;
      margin-bottom: 12px;
    }
    margin-bottom: 22px;
  }
`;

export const AllocationTileContentRow = styled.div<{ isHeader?: boolean }>`
  border-bottom: 1px solid ${ColorVariables.coco3};
  width: 100%;
  padding: 16px 0;

  ${(props) =>
    props.isHeader
      ? `
font-size: 12px;
line-height: 18px;
color: ${ColorVariables.coco7};
 `
      : `
 font-size: 14px;
  line-height: 22px;

 `}
  @media (min-width: 769px) {
    padding: 22px 0;

    ${(props) =>
      props.isHeader
        ? `
font-size: 14px;
line-height: 22px;
 `
        : `
 font-size: 16px;
  line-height: 24px;

 `}
  }
  display: flex;
  justify-content: center;
  align-items: center;

  &:last-child {
    border-bottom: none;
    padding-bottom: 12px;
  }
  > * {
    flex: 1;
    text-align: center;

    &:first-child {
      min-width: 37%;
      text-align: left;
    }

    &:last-child {
      min-width: 40%;
      display: none;
      @media (min-width: 769px) {
        display: block;
      }
    }
  }
`;

export const TableTileRow = styled.tr`
  padding: 12px 0;
  font-weight: 500;
`;

export const TableTileTable = styled.table`
  width: 100%;
  font-size: 12px;
  line-height: 18px;
  @media (min-width: 769px) {
    font-size: 14px;
    line-height: 22px;
  }
`;

export const TableTileRowHeader = styled.thead`
  color: ${ColorVariables.coco7};
  text-align: left;
  th {
    font-weight: 400;
  }
`;

export const AllocationTileProportionBar = styled.div<{ width: number }>`
  width: 100%;
  position: relative;
  height: 8px;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: ${(props) => props.width}%;
    background: ${ColorVariables.mint};
    border-radius: 8px;
    height: 8px;
  }
`;

export const AccountTileWrapper = styled(StyledClosableTile)`
  display: flex;
  flex-direction: column;
  position: relative;
  font-size: 18px;
  line-height: 26px;

  .edit-button {
    display: block;
    width: auto;
    padding: 0;
    border-radius: 0;
    font-weight: 600;
    color: ${ColorVariables.mint};
    font-size: inherit;
    line-height: inherit;
  }
  .remove-button {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 30px;
    height: 30px;
    &:hover {
      background: rgba(0, 0, 0, 0.05);
    }
  }
  .account-tile__label {
    font-size: 16px;
    font-weight: 400;
    color: ${ColorVariables.coco9};
  }
  .content-flex {
    padding-right: 10px;
    margin-top: 5px;
  }
`;

export const StyledIconRemove = styled(IconRemove)`
  width: 10px;
  height: 10px;
  fill: ${ColorVariables.coco3};
`;

export const MultiLineContentWrapper = styled.div<{ isLast: boolean }>`
  width: 100%;
  padding: 11px 0;
  border-bottom: 1px solid ${ColorVariables.coco3};
  position: relative;

  .heading-flex {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    .remove-button__heading {
      width: 30px;
      height: 30px;
    }
  }

  ${(props) =>
    props.isLast &&
    `
border-bottom:none;;
padding-bottom:0;
`}
  &:first-child {
    padding-top: 0;
  }
  .remove-button {
    top: 0;
    right: 0;
  }
`;
